// 去除文本空格
export const removeSpace = (text: any) => (typeof text === 'string' ? text.replace(/\s/g, '') : '')

// 是否是数字
export const isNumber = (v: any) => {
    if (isNaN(v)) {
        return false
    }

    if (!isFinite(v)) {
        return false
    }

    const a = parseFloat(v)

    return !isNaN(a)
}

// 拼接文本
export const concatText = (text: string, parents: { title: string }[]) =>
    parents
        .map(v => v.title)
        .concat(text)
        .filter(v => v && !isNumber(v))
        .join('_')
